
export default {
  name: 'BasePromoRegisterInProduct',
  props: {
    title: {
      type: String,
      default: 'Воспользоваться акцией',
    },
    description: {
      type: String,
      default: `Воспользоваться акцией могут только<br />зарегистрированные пользователи`,
    },
  },
}
